module.exports = __webpack_public_path__ + "static/media/grid-icon.9be69a88.svg";